import { LinkIcon } from '@phosphor-icons/react'

import { imageGroups } from './constants'

export const getStoreImages = storeTheme => ({
  logo: {
    preview: storeTheme?.logo_url,
    file: null,
    label: 'Logo tienda',
    recommendation: 'Max 50KB.',
    maxSize: 50,
    group: imageGroups.general,
  },
  returns_favicon: {
    preview: storeTheme?.returns_favicon_url,
    file: null,
    label: 'Favicon',
    recommendation: 'Formato PNG. Max 50kb. La imagen debe ser cuadrada. Recomendado 192x192px',
    maxSize: 50,
    aspectRatio: '1:1',
    group: imageGroups.general,
  },
  returns_background: {
    preview: storeTheme?.returns_background_url,
    file: null,
    label: 'Fondo (Desktop)',
    recommendation: 'Max 1MB. Recomendado 1920x1080px o más.',
    maxSize: 1024,
    group: imageGroups.backgrounds,
  },
  returns_background_mobile: {
    preview: storeTheme?.returns_background_mobile_url,
    file: null,
    label: 'Fondo (Mobile)',
    recommendation: 'Max 1MB. Recomendado 640x960px o más.',
    maxSize: 1024,
    group: imageGroups.backgrounds,
  },
  returns_cover: {
    preview: storeTheme?.returns_cover_url,
    file: null,
    label: 'Imagen portada',
    recommendation: 'Max 1MB. Recomendado 700x400px.',
    maxSize: 1024,
    accept: 'image/png, image/jpeg, image/jpg, image/webp',
    group: imageGroups.returnsPortal,
  },
  emails_footer_image: {
    preview: storeTheme?.emails_footer_image_url,
    file: null,
    label: 'Footer',
    recommendation: 'Max 300KB. Recomendado 600x300px.',
    maxSize: 300,
    group: imageGroups.emails,
    link: {
      key: 'emails_footer_url',
      url: storeTheme?.emails_footer_url || '',
      placeholder: 'Link de la imagen del footer',
      helperText: 'Añade el link al que dirigirá la imagen en el footer de los emails',
      Icon: LinkIcon,
    },
  },
  tracking_footer_image: {
    preview: storeTheme?.tracking_footer_image_url,
    file: null,
    label: 'Banner',
    recommendation: 'Máx 300KB.',
    maxSize: 300,
    group: imageGroups.tracking,
    link: {
      key: 'tracking_footer_url',
      url: storeTheme?.tracking_footer_url || '',
      placeholder: 'Link de la imagen del banner',
      helperText: 'Añade el link al que dirigirá la imagen del banner',
      Icon: LinkIcon,
    },
  },
})
